import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FsService } from 'src/app/service/fs.service';
import { registerLocaleData } from '@angular/common';
import localeIs from '@angular/common/locales/is';

@Component({
  selector: 'app-view-submitted-case',
  templateUrl: './view-submitted-case.component.html',
  styleUrls: ['./view-submitted-case.component.css']
})
export class ViewSubmittedCaseComponent implements OnInit, OnDestroy {
  clientId: string;
  caseId: string;
  submittedCaseCollection: Observable<any>;
  submittedCaseCollectionSub: Subscription;
  submittedCases: {};

  Title = 'Reikningar í umsókn';
  displayedColumns: { [key: string]: string } = {
    finalrefnumber: 'Vinnslunúmer',
    date: 'Dagsetning',
    issuer: 'Þjónustuveitandi',
    invoicenumber: 'Nr. reiknings',
    iskvat: 'Fjárhæð vsk ISK'
  };
  sizeOptions = ['50', '100'];
  sortOptions: { [key: string]: string } = { id: 'finalrefnumber', start: 'asc' };

  constructor(private route: ActivatedRoute, private fsf: FsService, private router: Router) {
    registerLocaleData(localeIs, 'is');
  }

  ngOnInit() {
    this.clientId = this.route.snapshot.paramMap.get('p1');
    this.caseId = this.route.snapshot.paramMap.get('p2');

    this.submittedCaseCollection = this.fsf.getSortedCaseInvoices(this.clientId, this.caseId);
    this.submittedCaseCollectionSub = this.submittedCaseCollection.subscribe(res => {
      this.submittedCases = res;
    });
  }

  table1rowFunc(row) {
    this.router.navigateByUrl('/viewsubmittedcaseinvoice/' + this.clientId + '/' + row.id + '/' + this.caseId);
  }

  ngOnDestroy() {
    if (this.submittedCaseCollectionSub) {
      this.submittedCaseCollectionSub.unsubscribe();
    }
  }
}
